import moment from "moment";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { imageUrl, stripePublicKey } from "../../config/apiUrl";
import Button from "../Button/Button";
import CartItem from "../cartItem/cartItem";
import PaymentModal from "../PaymentModal/PaymentModal";
import ShowMoreShowLessText from "../ShowMoreShowLess/ShowMoreShowLessText";

import classes from "./RequestItem.module.css";

// stripe
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
const stripePromise = loadStripe(stripePublicKey);

const RequestItem = ({ data, setCardRequestsData }) => {
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);

  return (
    <div className={classes?.container}>
      <Row>
        <Col md={6}>
          <div className={classes.image}>
            <img src={imageUrl(data?.photo)} />
          </div>
        </Col>
        <Col md={6}>
          <div className={classes.image}>
            <img src={imageUrl(data?.backPhoto)} />
          </div>
        </Col>
      </Row>
      <RowItem value={`${data?.name}`} />
      <Row>
        <Col md={9}>{moment(data?.createdAt).format("lll")}</Col>
        <Col md={3}>
          <span className={classes.font}>Status: </span>
          <span className="t-t-c">{data?.status}</span>
        </Col>
      </Row>
      {data?.status === "rejected" && (
        <Row>
          <p>
            <span
              style={{
                color: "red",
              }}
            >
              Rejection Reason:{" "}
            </span>
            <ShowMoreShowLessText text={data?.reason} />
          </p>
        </Row>
      )}

      {data?.status === "accepted" && (
        <Row className={classes?.acceptedDiv}>
          <p>
            Admin has successfully accepted your card request. Click{" "}
            <span onClick={() => setIsPaymentModalOpen(true)}>here</span> to pay
            now.
          </p>
        </Row>
      )}
      {data?.status === "paid" && (
        <Row className={classes?.acceptedDiv}>
          <p>
            Order in progress. Your parcel will be delivered to your doorstep.
          </p>
        </Row>
      )}
      {data?.status === "delivered" && (
        <Row className={classes?.acceptedDiv}>
          <p>Order delivered.</p>
        </Row>
      )}

      <RowItem value={`${data?.description}`} />

      <Elements stripe={stripePromise}>
        <PaymentModal
          data={data}
          show={isPaymentModalOpen}
          setShow={setIsPaymentModalOpen}
          setCardRequestsData={setCardRequestsData}
        />
      </Elements>
    </div>
  );
};

export default RequestItem;

const RowItem = ({ label, value }) => {
  return (
    <div className={classes?.reviewItem}>
      <p>
        {label && <b className="t-t-c">{label}:</b>}
        <ShowMoreShowLessText text={value} visibility={200} />
      </p>
    </div>
  );
};
